<template>
  <TGrid :cols="8">
    <div class="col-span-4 md:col-span-3">
      <TText classes="m-0" size="sm" variant="semibold">{{
        t('views.cottage-prices.summary.dateIn')
      }}</TText>
      <TText>{{ toRuralityDate().displayDate(dateIn) }}</TText>
    </div>
    <div class="col-span-4 md:col-span-5">
      <TText classes="m-0" size="sm" variant="semibold">{{
        t('views.cottage-prices.summary.dateOut')
      }}</TText>
      <TText>{{ toRuralityDate().displayDate(dateOut) }}</TText>
    </div>
    <div class="col-span-4 md:col-span-3">
      <TText classes="m-0" size="sm" variant="semibold">{{
        t('views.cottage-prices.summary.nights')
      }}</TText>
      <TText classes="mb-1">{{ nights }}</TText>
    </div>
    <div class="col-span-4 md:col-span-5">
      <TText classes="m-0" size="sm" variant="semibold">{{
        t('views.cottage-prices.summary.people')
      }}</TText>
      <TText classes="mb-1">{{ capacity }}</TText>
    </div>
    <ClientOnly>
      <div class="col-span-8">
        <ULink
          v-if="hasPrice"
          class="text-sm"
          :active="true"
          @click="$emit('openDateModal')"
          >{{ t('views.cottage-prices.summary.modify') }}</ULink
        >
      </div>
    </ClientOnly>
  </TGrid>
</template>
<script setup lang="ts">
import { usePricesStore } from '~~/modules/views/cottage-prices/stores/pricesStore'

interface PropsInterface {
  dateIn: string
  dateOut: string
  nights: number
  capacity: string
}

const pricesStore = usePricesStore()

const hasPrice = computed(() => pricesStore.getTotalPrice)

defineProps<PropsInterface>()
defineEmits(['openDateModal'])
</script>
